import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { EmployeeLevelEnum, PyramidType } from '../../../types'
import { DashbaordPyramidsData, PyramidsColumnGraphData } from '../../pyramids/pyramidUtils'
import { PyramidsColumnGraph } from '../../pyramids/visualization/PyramidsColumnGraph'
import '../styles/dashboard-pyramids-graph.less'

type Props = {
  data: DashbaordPyramidsData[]
  selectedLevelPill?: { label: string; value: EmployeeLevelEnum[] }
  onLevelLabelClick?: (levelPill: string) => void
}

const mapDashboardDataToColumnGraph = (data: DashbaordPyramidsData[]): PyramidsColumnGraphData[] =>
  data.map(({ name, current, currentCount, recommendedRange }) => ({
    name,
    current: { percentage: current, count: currentCount },
    recommendedRange,
  }))

export const DashboardPyramidsGraph: FC<Props> = ({ data, selectedLevelPill, onLevelLabelClick }) => {
  const { t } = useTranslation()

  return (
    <PyramidsColumnGraph
      data={mapDashboardDataToColumnGraph(data)}
      type={PyramidType.Level}
      variant="dashboard"
      chartAriaLabel={t('dashboard.companyManager.filtersArea.pyramids.chartAria')}
      showCurrent
      selectedLevelPill={selectedLevelPill}
      onLevelLabelClick={onLevelLabelClick}
    />
  )
}
